import './App.css';
import './styles/landing.css';
import './styles/landing-tech.css';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;